<app-breadcrumb></app-breadcrumb>
<div class="container" *ngIf="appService.theme$ | async as theme">
     <div class="main-container-feedback" *ngIf="empNumber$ | async as empNumber">
          <form class="form" [formGroup]="form" (ngOnSubmit)="onSubmit()">
               <div class="header-body"
                    [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
                    <div class="title">Feedback</div>
                    <p class="body">
                         This is the beta version of the Logbook application. Before submitting feedback,
                         kindly review the FAQs or Known Issues section on the Version Details page. As
                         we continue to enhance the application, we appreciate your detailed feedback,
                         including screenshots. Finally, please send each issue as a separate feedback
                         submission.
               </div>
               <div class="item-container">
                    <p-dropdown id="feedbackType" formControlName="feedbackType" [options]="feedbackTypes"
                         placeholder="Feedback Type" />
               </div>
               <div class="item-container">
                    <p-dropdown id="view" formControlName="view" [options]="viewTypes" placeholder="App View" />
               </div>
               <div class="item-container">
                    <p-inputMask class="contactNumber" id="contactNumber" formControlName="contactNumber" mask="999-999-9999"
                         placeholder="Contact Number (Optional)" />
               </div>
               <div class="item-container">
                    <textarea [dt]="textArea" pTextarea id="feedbackText" formControlName="feedbackText" placeholder="Feedback"
                         rows="5"></textarea>
               </div>
          </form>
          <div class="button-container">
               <div class="row-btn">
                    <button class="form-btn" pButton pRipple type="button" [disabled]="form.pristine && !form.valid"
                         (click)="onReset()">
                         Reset
                    </button>
                    <button class="form-btn" pButton pRipple type="submit" [disabled]="form.invalid"
                         (click)="onSubmit()">
                         Submit
                    </button>
               </div>
          </div>
     </div>
</div>